import { Button, Stack, Tab, Typography } from "@mui/material";
import ReportScreen from "../../../../common/enums/ReportScreens";
import ReportFiltersComponent from "../ReportFiltersComponent";
import ReportFiltersLoading from "../ReportFiltersLoading";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import { useEffect, useState } from "react";
import ExecutiveSummaryTable from "./executive-summary-table/ExecutiveSummaryTable";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { RegionType } from "../../../../domain/models/executive-summary/executive-summary-type";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DownloadIcon from "@mui/icons-material/Download";
import TopBottomExecutiveSummary from "./sub-component/TopBottomExecutiveSummary";
import { DownloadJSONExecutive } from "../../../../domain/models/executive-summary/download-json-executive";
import { TerritoryDataStore } from "../../../../store/main/TerritoryDataStore";
import ExecutiveSummaryBar from "./sub-component/ExecutiveSummaryBar";

const ExectiveSummaryDesktop = () => {
  const data: RegionType[] = [
    {
      region_id: 1,
      region_name: "North1",
      rbm_name: "PulkitRBM",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 25500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 74500,
              invoices_count: 73,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi2",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi3",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      region_id: 2,
      region_name: "North2",
      rbm_name: "PulkitRBM",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi2",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi3",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      region_id: 3,
      region_name: "North3",
      rbm_name: "PulkitRBM",
      areas: [
        {
          area_id: 11,
          area_name: "Delhi1",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi2",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
        {
          area_id: 11,
          area_name: "Delhi3",
          abm_name: "PulkitABM",
          orders_target: 23,
          orders: 23,
          target: 24500,
          sales: 24500,
          percentage: 132,
          growth: 45,
          channelPay: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          channelPaisa: {
            current_month: {
              invoices: 24500,
              invoices_count: 23,
              order: 24500,
              order_count: 23,
              total: 100,
              active: 40,
            },
            previous_months: [
              {
                month: 4,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 3,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
              {
                month: 2,
                invoices: 24500,
                invoices_count: 23,
                order: 24500,
                order_count: 23,
                total: 100,
                active: 40,
              },
            ],
          },
          headquarters: [
            {
              hq_id: 112,
              hq_name: "Gurugram",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "New Delhi West",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
            {
              hq_id: 112,
              hq_name: "Rohtak",
              tso_name: "pulkit TSO",
              orders_target: 23,
              orders: 23,
              target: 24500,
              sales: 24500,
              percentage: 132,
              growth: 45,
              channelPay: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
              channelPaisa: {
                current_month: {
                  invoices: 24500,
                  invoices_count: 23,
                  order: 24500,
                  order_count: 23,
                  total: 100,
                  active: 40,
                },
                previous_months: [
                  {
                    month: 4,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 3,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                  {
                    month: 2,
                    invoices: 24500,
                    invoices_count: 23,
                    order: 24500,
                    order_count: 23,
                    total: 100,
                    active: 40,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ];

  const { userDetails, userRole, decodeToken, downloadExcelTable } =
    CustomerDatabaseStore();
  const { fetchCustomerTypes } = TerritoryDataStore();
  const [value, setValue] = useState<string>(data[0].region_id.toString());
  const [topBottom, setTopBottom] = useState<boolean>(false);
  const [expandAll, setExpandAll] = useState<boolean>(false);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [downloadJSON, setDownloadJSON] = useState<DownloadJSONExecutive[]>([]);
  useEffect(() => {
    decodeToken();
    fetchCustomerTypes();
  }, []);
  useEffect(() => {
    setDownloadJSON([]);
  }, [topBottom, expandAll]);

  const downloadExcel = () => {
    // console.log(downloadJSON);
    // if (downloadJSON.length !== 0) downloadExcelTable(downloadJSON);
  };

  const filterData = () => {};
  const clearData = () => {};
  return (
    <>
      <Stack paddingY={2}>
        {Object.keys(userDetails).length > 0 ? (
          <ReportFiltersComponent
            type={ReportScreen.EXECUTIVE_SUMMARY}
            successCallback={filterData}
            clearSuccessCallBack={clearData}
            userRole={userRole.role}
            userDetails={userDetails}
            gridColumns={14}
            territoryMultiSelect={false}
          />
        ) : (
          <ReportFiltersLoading />
        )}
      </Stack>
      <ExecutiveSummaryBar />
      <Stack direction={"row"} gap={1} py={2}>
        <Button
          sx={{
            background:
              "linear-gradient(to bottom, rgb(120, 168, 242) 1%, rgb(64, 133, 237) 99%)",
            color: "white",
          }}
          onClick={() => {
            setTopBottom(!topBottom);
          }}
        >
          SEE TOP 50
        </Button>
        <Button
          sx={{
            background:
              "linear-gradient(to bottom, rgb(242, 122, 122) 1%, rgb(237, 64, 64) 99%)",
            color: "white",
          }}
          onClick={() => {
            setTopBottom(!topBottom);
          }}
        >
          SEE BOTTOM 50
        </Button>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={downloadExcel}
        >
          Download
        </Button>
        {!topBottom && (
          <Button
            sx={{ minWidth: 150 }}
            variant="contained"
            onClick={() => {
              setExpandAll(!expandAll);
            }}
            startIcon={
              !expandAll ? (
                <KeyboardArrowDownIcon fontSize="small" />
              ) : (
                <KeyboardArrowUpIcon fontSize="small" />
              )
            }
          >
            {!expandAll ? "Expand All" : "Close All"}
          </Button>
        )}
      </Stack>

      {topBottom ? (
        <TopBottomExecutiveSummary downloadJSON={downloadJSON} />
      ) : (
        <>
          {expandAll ? (
            <Stack gap={3}>
              {data.map((region) => (
                <Stack gap={2}>
                  <Typography variant="h6" fontWeight={600}>
                    {region.region_name}
                  </Typography>
                  <ExecutiveSummaryTable
                    data={region.areas}
                    downloadJSON={downloadJSON}
                  />
                </Stack>
              ))}
            </Stack>
          ) : (
            <>
              <Stack>
                <TabContext value={value}>
                  <TabList onChange={handleChange}>
                    {data.map((region) => (
                      <Tab
                        label={region.region_name}
                        value={region.region_id.toString()}
                      />
                    ))}
                  </TabList>
                  {data.map((region) => (
                    <TabPanel value={region.region_id.toString()}>
                      <ExecutiveSummaryTable
                        data={region.areas}
                        downloadJSON={downloadJSON}
                      />
                    </TabPanel>
                  ))}
                </TabContext>
              </Stack>
            </>
          )}
        </>
      )}
    </>
  );
};

export default ExectiveSummaryDesktop;
